// extracted by mini-css-extract-plugin
export var watermark = "WatermarkFour-module--watermark--x4sJ1";
export var watermarkContainer = "WatermarkFour-module--watermarkContainer--fE16g";